import { render, staticRenderFns } from "./orgInfo.vue?vue&type=template&id=bb81a2b0"
import script from "./orgInfo.vue?vue&type=script&lang=js"
export * from "./orgInfo.vue?vue&type=script&lang=js"
import style0 from "./orgInfo.vue?vue&type=style&index=0&id=bb81a2b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports